// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"733":"648f1760","871":"42221b47"}[chunkId] + ".chunk.css";
};